import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "application",
  "use": "application-usage",
  "viewBox": "0 0 9 10",
  "content": "<symbol viewBox=\"0 0 9 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"application\">\r\n<path d=\"M0.222275 0.235294H7.44623V2.23529H0.222275V0.235294Z\" />\r\n<path d=\"M0.351473 0.36192H7.31703V5.00885L7.6685 5.1V0H0V10H7.6685V9.62053L7.31703 9.27723V9.63808H0.351473V0.36192Z\" />\r\n<path d=\"M9 8.41103L8.06677 9.35597L6.62451 7.89561L5.94579 8.58284L5.26708 5.49031L8.23645 6.26344L7.55774 6.95067L9 8.41103Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol